(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
document.querySelectorAll('.alk-mobile-nav a').forEach(function(link){link.addEventListener('click',function(){link.closest('details').open=false;});});

  } catch(e) { console.error(e); }
})();
})();
